import tw from 'tailwind-styled-components'

export const Wrapper = tw.div`
  flex flex-row items-center gap-10
`;

export const IconLink = tw.a`
  text-white
`;
